import './styles.scss';

import React, {CSSProperties, PropsWithChildren} from 'react';

export enum AppInfoMode {
    BLOCK = '',
    TEXT = 'text',
}
export enum AppInfoView {
    INFO = '',
    WARNING = 'warning',
}

interface AppInfoProps extends PropsWithChildren {
    mode?: AppInfoMode;
    view?: AppInfoView;
    style?: CSSProperties;
}

export const AppInfo = ({
    style,
    mode = AppInfoMode.BLOCK,
    view = AppInfoView.INFO,
    children,
}: AppInfoProps) => {
    return (
        <div style={style} className={`app-info ${mode} ${view}`}>
            <div className='app-info__content'>{children}</div>
        </div>
    );
};
